export const fr = {
  translation: {
    noAccess: {
      title: "Accès restreint",
      message: "Vous n'avez pas accès à cette section.",
    },
    noRestaurant: {
      title: "Aucun restaurant",
      message:
        "Vous n'avez encore accès à aucun restaurant. Veuillez contacter votre administrateur pour obtenir un accès.",
      unsubscribed: {
        title: "Votre abonnement est terminé",
        message:
          "Votre organisation détient toujours les établissements ci-dessous. Ouvrez les paiements d'un établissement pour consulter ce que vous avez déjà payé, ou déclarez un paiement pour vous réabonner.",
        viewPayments: "Paiements",
      },
    },
    common: {
      pagination: {
        rowsPerPage: "Lignes par page :",
        displayedRows: "{{from}}–{{to}} sur {{total}}",
      },
      save: "Sauvegarder",
      gotIt: "J'ai compris",
      saveChanges: "Sauvegarder Les Changemenets",
      cancel: "Annuler",
      edit: "Modifier",
      delete: "Supprimer",
      email: "address email",
      submit: "Soumettre",
      tags: "Tags",
      phone: "N° de téléphone",
      days: {
        MONDAY: "Lundi",
        TUESDAY: "Mardi",
        WEDNESDAY: "Mercredi",
        THURSDAY: "Jeudi",
        FRIDAY: "Vendredi",
        SATURDAY: "Samedi",
        SUNDAY: "Dimanche",
      },
      months: {
        1: "Janvier",
        2: "Février",
        3: "Mars",
        4: "Avril",
        5: "Mai",
        6: "Juin",
        7: "Juillet",
        8: "Août",
        9: "Septembre",
        10: "Octobre",
        11: "Novembre",
        12: "Décembre",
      },
      error: "Une erreur est survenue, veuillez réessayer",
      noData: "Aucune donnée sur cette période",
    },
    emailVerification: {
      body: "Votre compte est en cours de verification, veuillez patienter",
      crash: "Une erreur est survenu, veuillez ressayer plus tard",
      website: {
        success:
          "Votre compte a été vérifier avec succès, vous serez rediriger dans quelque secondes",
        error:
          "Votre token a malheureusement expiré, veuillez ressayer depuis l'écran de connexion",
      },
      mobile: {
        success:
          "Votre compte a été vérifier avec succès, vous pouvez vous connecter depuis l'application mobile",
        error:
          "Votre token a malheureusement expiré, veuillez ressayer depuis l'application mobile",
      },
    },
    landingPage: {
      nav: {
        ecosystem: "Écosystème",
        features: "Fonctionnalités",
        analytics: "Analytiques",
        pricing: "Tarifs",
        requestDemo: "Demander une démo",
        openMenu: "Ouvrir le menu",
      },
      hero: {
        title: "Le seul outil qui vous amène des clients — et remplit votre salle.",
        subtitle:
          "L'Addition connecte les milliers de gourmets de notre application à votre restaurant, puis réunit réservations, plan de salle, offres, menu et analytics dans une seule plateforme.",
        cta: "Demander une démo",
        secondaryCta: "Voir les fonctionnalités",
      },
      ecosystem: {
        title: "Un écosystème qui tourne dans les deux sens.",
        subtitle:
          "Vos clients réservent depuis l'application ou depuis votre page de réservation dédiée ; vos offres et événements y apparaissent — tout circule entre l'application grand public et votre tableau de bord.",
        appTag: "📱 L'application",
        bookingPageTag: "🔗 Votre page de réservation dédiée",
        caption:
          "Vos clients réservent depuis l'app ou depuis votre page de réservation dédiée — hébergée par nous. Les offres et événements que vous créez dans votre tableau de bord y apparaissent aussitôt, devant des milliers de gourmets.",
        appScreenAlt: "Application L'Addition — écran de réservation",
        bookingPage: {
          url: "laddition.ma/booking/Casa",
          restaurantName: "Votre restaurant",
          chooseDate: "Choisir une date",
          chooseDateSub: "Choisissez parmi nos dates disponibles",
          legendAvailable: "Disponible",
          legendOffer: "Offre",
          legendEvents: "Événements",
          month: "Mai 2026",
        },
        dashboard: {
          restaurantSelector: "L'Atelier — Casablanca · Centre-ville",
          date: "Vendredi 15 mai 2026",
          greeting: "Bonjour, Karim",
          greetingSub: "Voici l'activité de votre restaurant aujourd'hui.",
          generalStats: "Statistiques générales",
          bookings: "Réservations",
          covers: "Couverts",
          occupancy: "Occupation",
          bookingsToday: "Réservations du jour",
          bookingsTodaySub: "Vendredi 15 mai · 78 couverts",
          seeAll: "Voir tout →",
          confirmed: "Confirmée",
          quietSlots: "Créneaux creux",
          quietSlotsSub: "Tables occupées par tranche · service du jour",
          quietMessage: "15:00 → 18:00 est presque vide.",
          quietMessageEnd: " Une offre peut remplir ces tables.",
          quietCta: "Créer une offre",
          offersEvents: "Offres & Événements",
          offersEventsSub: "Ce qui apparaît dans l'app",
          create: "+ Créer",
          liveMusic: "Live music",
          liveMusicTag: "Événement · Ven. 21h",
          happyHour: "−20% happy hour",
          happyHourTag: "Offre · 18h–20h",
        },
      },
      showcase: {
        title: "Plus de 30 fonctionnalités, un seul écran.",
        subtitle:
          "Réservations, plan de salle, offres, menu, analytics, équipe… tout votre restaurant réuni sur une seule plateforme.",
        bookings: {
          tab: "Réservations en temps réel",
          title: "Réservations en temps réel",
          description:
            "Recevez, confirmez et suivez chaque réservation en direct, quel que soit le canal — et maîtrisez les no-shows grâce à la confirmation WhatsApp et à une blacklist.",
          checks: {
            whatsapp: "Confirmation client par WhatsApp en un clic",
            blacklist:
              "Blacklist des clients no-show récurrents pour protéger vos tables",
            statuses: "Statuts en direct : confirmée, arrivée, no-show",
            views: "Vue du jour, à venir et historique",
          },
        },
        offPeak: {
          tab: "Heures creuses",
          title: "Transformez vos heures creuses en chiffre d'affaires",
          description:
            "Créez une offre ciblée sur vos tranches vides et poussez-la dans l'application. L'Addition mesure ensuite combien de couverts sont réellement tombés dans le créneau visé — pas ailleurs.",
          checks: {
            oneClick: "Offres et événements activables en un clic",
            visualize: "Visualisation des tables occupées par tranche horaire",
            impact: "Suivi de l'impact réel de chaque offre sur les couverts",
          },
          coversPerSlot: "Couverts par tranche",
          targetWindow: "Fenêtre ciblée",
        },
        floorPlan: {
          tab: "Plan de salle",
          title: "Plan de salle & grille du jour",
          description:
            "Une grille visuelle de votre salle : glissez chaque réservation sur sa table, heure par heure, sans jamais doubler une table.",
          checks: {
            dragDrop: "Glisser-déposer des réservations sur les tables",
            noDoubleBooking: "Vue par créneau, sans double-booking",
            unassigned: "Réservations non attribuées en un coup d'œil",
          },
        },
        analytics: {
          tab: "Analytiques avancées",
          title: "Analytiques avancées",
          description:
            "Chaque service alimente un tableau de bord clair : taux d'occupation, heures de pointe, taille des groupes et performance par jour.",
          checks: {
            trend: "Tendance des réservations et heures de pointe",
            breakdown: "Répartition par taille de groupe et par jour",
            offerImpact: "Impact chiffré de chaque offre et événement",
          },
          occupancyRate: "Taux d'occupation",
          coversPerWeek: "Couverts / semaine",
          avgPartySize: "Taille moyenne du groupe",
          bestDay: "Meilleur jour",
          bestDayValue: "Vendredi",
        },
        menu: {
          tab: "Menu & QR Code",
          title: "Menu & QR Code",
          description:
            "Gérez vos plats et catégories, mettez en avant vos signatures, et partagez votre carte digitale via un QR Code à table.",
          checks: {
            editable: "Plats, catégories et prix modifiables à tout moment",
            signature: "Mise en avant de vos plats signatures",
            qrCode: "Carte partageable par QR Code",
            published: "Menu publié directement dans l'application L'Addition",
          },
          dishes: {
            salad: "Salade César",
            tajine: "Tajine signature",
            dessert: "Fondant chocolat",
          },
        },
        gallery: {
          tab: "Galerie & visibilité",
          title: "Galerie & visibilité",
          description:
            "Photo de couverture, galerie du restaurant et du menu : soignez la page que voient vos futurs clients avant de réserver.",
          checks: {
            galleries: "Photo de couverture et galeries restaurant + menu",
            storefront: "Une vitrine attractive dans l'application",
            seasonal: "Mise à jour au fil de vos offres saisonnières",
          },
          alts: {
            diningRoom: "Salle de restaurant",
            setTable: "Table dressée",
            ambience: "Ambiance restaurant",
          },
        },
        team: {
          tab: "Équipe & multi-restaurants",
          title: "Équipe & multi-restaurants",
          description:
            "Invitez votre personnel, attribuez des rôles précis, et pilotez plusieurs établissements depuis un seul compte.",
          checks: {
            roles: "Rôles et accès dédiés par membre",
            switch: "Bascule entre établissements en un clic",
            centralized: "Gestion centralisée pour les groupes",
          },
          roles: {
            manager: "Manager",
            receptionist: "Réceptionniste",
            waiter: "Serveur",
            venues: "2 établissements",
          },
        },
      },
      analyticsSection: {
        title: "Prenez des décisions basées sur les données",
        subtitle:
          "Tableaux de bord en temps réel qui vous donnent une vue complète de votre activité.",
        bookings: "Réservations",
        guests: "Invités",
        fillRate: "Taux de remplissage",
        growthRate: "Taux de croissance",
        vsLastMonth: "↗ vs mois dernier",
        bookingsTrend: "Tendance des Réservations",
        bookingsTrendAlt: "Tendance des réservations sur la semaine",
        bookingsByHour: "Réservations par heure de service",
        offersPerformance: "Performance de vos offres",
        eventsPerformance: "Performance de vos événements",
        offerColumn: "Offre",
        coversColumn: "Couverts",
        deltaColumn: "Δ",
        days: {
          mon: "Lun",
          tue: "Mar",
          wed: "Mer",
          thu: "Jeu",
          fri: "Ven",
          sat: "Sam",
          sun: "Dim",
        },
        shortDays: {
          mon: "Lu",
          tue: "Ma",
          wed: "Me",
          thu: "Je",
          fri: "Ve",
          sat: "Sa",
          sun: "Di",
        },
      },
      clientApp: {
        title: "Votre vrai avantage : une app qui vous amène des clients.",
        subtitle:
          "L'Addition est la seule plateforme au Maroc adossée à une application grand public. Vos deals du jour et vos événements y apparaissent devant des milliers de gourmets — et se transforment en couverts.",
        checks: {
          discover:
            "Découverte des restaurants, rooftops et bonnes adresses par ville",
          deals: "Vos deals du jour dans la rubrique « Ce soir »",
          events: "Vos événements & expériences réservables en deux tapes",
          favorites: "Favoris, avis et partage entre amis",
        },
        downloadOn: "Télécharger sur",
        appStore: "App Store",
        availableOn: "Disponible sur",
        googlePlay: "Google Play",
        screenshotAlt:
          "Application L'Addition — carte des restaurants et bons plans à Casablanca",
      },
      steps: {
        title: "Opérationnel en 24h, en trois étapes.",
        one: {
          title: "Créez votre espace",
          body: "Ajoutez votre restaurant : nom, adresse, capacité, horaires. Quelques minutes suffisent.",
        },
        two: {
          title: "Configurez menu & salle",
          body: "Importez votre carte, dessinez votre plan de salle et publiez votre galerie photo.",
        },
        three: {
          title: "Prêt en 24h",
          body: "En moins de 24h, votre compte est configuré et prêt à recevoir des réservations. Vous les gérez en direct et vos offres remplissent les heures creuses.",
        },
      },
      pricing: {
        title: "Deux modules, un tarif clair.",
        subtitle:
          "Choisissez selon votre salle. Sans commission sur vos couverts — vous gardez 100% de votre chiffre d'affaires.",
        firstMonthFree: "🎁 1er mois offert",
        cta: "Commencer",
        multi: {
          title: "Vous gérez plusieurs restaurants ?",
          body: "Chaînes, groupes et hôtels : pilotez tous vos établissements depuis un seul compte, avec des rôles dédiés et un accompagnement sur mesure.",
          cta: "On peut en parler",
        },
      },
      faq: {
        title: "Ce qu'on nous demande le plus.",
        modules: {
          q: "Quelle différence entre les modules Visibilité et Réservation ?",
          a: "« Visibilité » remplit vos services creux au jour le jour avec des deals publiés dans l'app — idéal si vous marchez au walk-in. « Réservation » ajoute les réservations à date future, le plan de salle et les événements & expériences réservables. Le module Réservation inclut tout le module Visibilité.",
        },
        setup: {
          q: "Combien de temps pour être opérationnel ?",
          a: "La plupart des restaurants sont prêts à recevoir des réservations en moins de 24h : infos, horaires, menu et plan de salle. Notre équipe vous accompagne pour l'import de votre carte.",
        },
        whatsapp: {
          q: "Comment fonctionne la confirmation WhatsApp ?",
          a: "Depuis chaque réservation, vous confirmez le client en un clic sur WhatsApp. C'est le canal le plus utilisé au Maroc, ce qui réduit fortement les no-shows.",
        },
        commission: {
          q: "Prenez-vous une commission sur mes réservations ?",
          a: "Non. L'Addition est un abonnement mensuel fixe. Vous gardez 100% du chiffre d'affaires de vos couverts, offres comprises.",
        },
        multiRestaurant: {
          q: "Puis-je gérer plusieurs restaurants ?",
          a: "Oui. Vous basculez entre vos établissements depuis un seul compte, avec des rôles et des accès dédiés pour chaque équipe.",
        },
        offPeak: {
          q: "Que sont les « heures creuses » et les offres ?",
          a: "Votre tableau de bord repère les tranches horaires les plus vides. Vous y associez une offre poussée dans l'application L'Addition, puis vous mesurez les couverts réellement gagnés sur ce créneau.",
        },
        commitment: {
          q: "Y a-t-il un engagement ?",
          a: "Aucun. L'abonnement est mensuel et résiliable à tout moment depuis votre espace.",
        },
      },
      demo: {
        title: "Vos tables vous attendent.",
        subtitle:
          "Rejoignez les restaurants de Casablanca qui remplissent leur salle avec L'Addition. Demandez une démo, on s'occupe du reste.",
        fields: {
          managerName: "Nom du Gérant",
          email: "Email",
          phone: "Téléphone",
          restaurantName: "Nom du Restaurant",
          city: "Ville",
          howDidYouHear: "Comment avez-vous entendu parler de nous ?",
          message: "Message (optionnel)",
        },
        cityOptions: {
          casablanca: "Casablanca",
          rabat: "Rabat",
          marrakech: "Marrakech",
          fes: "Fès",
          tanger: "Tanger",
          agadir: "Agadir",
          other: "Autre",
        },
        hearOptions: {
          socialMedia: "Instagram",
          friend: "Recommandation",
          google: "Recherche Google",
          event: "Événement",
          other: "Autre",
        },
        cta: "Demander une Démo",
        success: "Votre demande a bien été envoyée !",
        error: "Une erreur est survenue, veuillez réessayer",
        errorEmailTaken:
          "Cette adresse email est déjà liée à une demande existante.",
        errorPhoneTaken:
          "Ce numéro de téléphone est déjà lié à une demande existante.",
      },
      subscriptionTiers: {
        buttonLabel: "Choisissez votre abonnement",
        buttonSelected: "Formule : {{- tier}}",
        modalTitle: "Choisissez votre formule",
        modalSubtitle: "Sélectionnez la formule adaptée à votre restaurant.",
        popular: "Le plus populaire",
        priceSuffix: "DH / mois HT",
        annualRate: "{{amount}} DH/mois en annuel",
        selectCta: "Choisir cette formule",
        selectedCta: "Sélectionnée",
        required: "Veuillez choisir une formule d'abonnement",
        loadError: "Impossible de charger les formules. Veuillez réessayer.",
        tiers: {
          visibilite: {
            title: "Visibilité — Offres & Événements",
            description: "Remplissez vos services creux.",
          },
          reservation: {
            title: "Réservation",
            description: "Tout le module Visibilité, plus :",
          },
        },
      },
      footer: {
        tagline:
          "La plateforme de découverte et de gestion pour les restaurants du Maroc. Un produit VastTech, Casablanca.",
        product: "Produit",
        features: "Fonctionnalités",
        analytics: "Analytiques",
        pricing: "Tarifs",
        company: "Entreprise",
        requestDemo: "Demander une démo",
        contact: "Nous contacter",
        instagram: "@laddition_maroc",
        legal: "Légal",
        legalNotice: "Mentions légales",
        privacy: "Confidentialité",
        terms: "Conditions",
        googlePlay: "Google Play",
        appStore: "App Store",
        copyright: "© 2026 L'Addition · VastTech SARL, Casablanca.",
        madeIn: "Fait au Maroc 🇲🇦",
      },
    },
    homePage: {
      header: "Attirez plus de clients",
      secondHeader: "Augmentez votre fréquentation",
      subheader:
        "Avec L'addition,<strong> gérez les réservations</strong> de votre restaurant, <strong>proposez des offres</strong> aux clients et <strong>augmentez votre visibilité</strong> en ligne, le tout dans un seul environnement!",
      discoverCta: "Découvrir",
      comingSoon: "Bientôt disponible",
    },
    footer: {
      about: "À propos",
      termsAndConditions: "Conditions d'utilisation",
      contact: "Contact",
      downloadTheApp: "Télécharger l'application :",
      phone: "Téléphone: {{phone}}",
    },
    profileDropDown: {
      changePassword: "Changer mon mot de passe",
      logout: "Se déconnecter",
      emailSent:
        "Un email a été envoyé, veuillez vérifier votre boîte de réception",
    },
    About: "À propos",
    signIn: {
      cta: "Se connecter",
      dashboard: "Mon tableau de bord",
      header: "Hey, Bon Retour!",
      subHeader: "Entrez vos informations pour vous connecter à votre compte",
      email: "Adresse Email",
      password: "Mot de passe",
      rememberMe: "Se souvenir de moi",
      forgotPassword: "Mot de passe oublié?",
      noAccount: "Vous n'avez pas de compte?",
      errors: {
        credentialsMissing: "Veuillez remplir tous les champs",
        credentialsInvalid: "L'email ou le mot de passe est incorrect",
        notVerified:
          "Votre compte n'a pas été vérifié, veuillez vérifier votre email",
        wrongAccountType:
          "Ce compte n'est pas un compte restaurateur, veuillez vous connecter depuis l'application mobile",
      },
    },
    signUp: {
      cta: "S'inscrire",
      header: "Créez votre compte",
      subheader:
        "Inscrivez-vous dès maintenant Entrez vos informations pour créer votre compte et commencez à gérer vos restaurants en toute liberté. Profitez des avantages de notre plateforme pour augmenter le trafic de vos clients et optimiser la gestion de votre établissement.",
      createAccount: "Soumettre ma demande",
      creationSuccess:
        "Votre demande a été soumise avec succès, nous la vérifierons et vous répondrons dès que possible",
      creationError: "Erreur lors de la création de votre demande",
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        email: "Adresse Email",
        phone: "Numéro de téléphone",
        restaurantName: "Nom du restaurant",
        city: "Ville",
      },
    },
    booking: {
      header: "Réserver une table",
      subheader:
        "Réservez une table dans <strong>{{restaurant_name}}</strong> pour une expérience culinaire inoubliable",
      form: {
        firstName: "Prénom",
        lastName: "Nom",
        numberOfPeople: "Nombre de personnes",
        submit: "Suivant",
        email: "Adresse Email",
        phone: "Numéro de téléphone",
        book: "Réserver",
        cancel: "Annuler",
      },
      creationSuccessHeader: "Réservation réussie",
      creationSuccessHelper:
        "{{restaurant_name}} a bien reçu votre réservation, il vous contacterons pour confirmer votre réservation",
      creationError:
        "Une erreur est survenue lors de la réservation, veuillez réessayer",
      slotsFull:
        "Il semblerait que quelqu'un ait déjà réservé toutes les places pour ce créneau, veuillez en choisir un autre",
    },
    clientBooking: {
      selectDate: "Choisir une Date",
      selectDateSubtitle: "Choisissez parmi nos dates disponibles ci-dessous",
      available: "Disponible",
      specialDeal: "Offre Spéciale",
      selectTime: "Choisir un Horaire",
      back: "Retour",
      morning: "Matin",
      evening: "Soir",
      numGuests: "Nombre de Convives",
      numGuestsSubtitle: "Combien de personnes seront à table ?",
      guests: "Convives",
      quickSelect: "Sélection rapide :",
      continueCta: "Continuer",
      largePartyNote:
        "Pour les groupes de plus de {{max}} personnes, veuillez nous appeler au {{phone}}",
      largePartyNoteNoLimit:
        "Pour les grands groupes, veuillez nous appeler au {{phone}}",
      yourDetails: "Vos Coordonnées",
      completeReservation: "Complétez votre réservation",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Numéro de téléphone",
      specialRequests: "Demandes Spéciales (Optionnel)",
      specialRequestsPlaceholder:
        "Allergies, régimes alimentaires, occasions spéciales...",
      confirmReservation: "Confirmer la Réservation",
      openHours: "Ouvert : {{hours}}",
      reviews: "{{count}} avis",
      offDiscount: "{{discount}}% de réduction",
      guestCountSummary: "{{count}} Convives",
      required: "Ce champ est obligatoire",
      invalidEmail: "Veuillez saisir une adresse email valide",
      bookingSuccess: "Réservation Confirmée !",
      bookingSuccessMessage:
        "Votre réservation chez {{restaurant}} a été confirmée. Nous vous attendons avec impatience !",
      bookingError: "Une erreur est survenue, veuillez réessayer",
      errorLoading:
        "Impossible de charger les informations du restaurant. Veuillez réessayer.",
      restaurantNotFound: "Ce restaurant n'existe pas.",
      notAcceptingBookings: "Ce restaurant n'accepte pas encore les réservations en ligne.",
    },
    publicMenu: {
      priceNote: "Prix en dirhams · Service compris",
      itemPrice: "{{price}} DH",
      restaurantNotFound: "Ce restaurant n'existe pas.",
      errorLoading:
        "Impossible de charger le menu du restaurant. Veuillez réessayer.",
    },
    AboutPage: {
      Mission: {
        Header: "Notre Mission",
        Body: "Chez <strong>L'Addition</strong>, nous visons à révolutionner et enrichir l'industrie de la restauration haut de gamme au <strong>Maroc</strong> en connectant des restaurateurs passionnés et des clients enthousiastes.\n\nNous croyons en la création d'une communauté culinaire dynamique, où <strong>chaque restaurant a l'opportunité de briller</strong>, et où chaque client peut découvrir son prochain endroit préféré.\n\nExploitez la puissance d'Internet pour placer votre restaurant au centre de l'attention et dans le cœur de vos clients.",
      },
      Services: {
        Header: "Nos Services",
        Body: "Bienvenue sur <strong>L'Addition</strong>, la nouvelle plateforme en ligne pour les <strong>propriétaires de restaurants au Maroc</strong> afin de présenter leurs établissements et de gérer leurs services de réservation.\n\nCréez votre compte dès maintenant pour enregistrer vos restaurants et gérez tout, de vos horaires et menus à vos offres et réservations, de manière simple et efficace.",
        Restaurants: {
          Header: "Gestion des Restaurants",
          Body: "Vous pouvez enregistrer et gérer <strong>autant de restaurants que vous le souhaitez</strong> pour les mettre sur la carte.\n\nAyez un <strong>contrôle total</strong> sur leurs horaires respectifs, menus, offres, etc...",
        },
        Calendar: {
          Header: "Gestion du Calendrier",
          Body: "Établissez un calendrier d'heures d'ouverture et de fermeture pour informer les clients de votre semaine typique.\n\nAjoutez des jours de congé au calendrier pour gérer d'éventuelles constructions non planifiées ou vacances.",
        },
        Menu: {
          Header: "Gestion du Menu",
          Body: "Vous pouvez rendre votre menu disponible à tous vos clients, que ce soit sous forme de texte simple, d'images ou les deux.\n\nEffectuez toutes les modifications nécessaires quand vous le souhaitez et comme vous le souhaitez.",
        },
        Deals: {
          Header: "Gestion des Offres",
          Body: "Envie d'offrir des offres séduisantes à vos clients ? Mettez en place des offres avec une description personnalisée et activez ou désactivez facilement pour chaque restaurant.",
        },
        Reservations: {
          Header: "Gestion des Réservations",
          Body: "Le service principal de la plateforme est la capacité de gérer toutes vos futures réservations tout en gardant un œil sur celles du passé.",
        },
      },
    },
    contactPage: {
      header:
        "Vous rencontrez un problème avec notre site? Créez un ticket ci-dessous",
      subHeader:
        "Nos équipes feront de leur mieux pour résoudre votre soucis rapidement",
      form: {
        content: "Décrivez votre problème",
      },
    },
    featureLocked: {
      upgrade: {
        title: "{{feature}} ne fait pas partie de votre formule",
        message:
          "Votre abonnement n'inclut pas {{feature}} pour ce restaurant. Passez à une formule supérieure pour y accéder.",
        action: "Accéder au paiement",
      },
      permission: {
        title: "Accès à {{feature}} restreint",
        message:
          "Demandez à l'administrateur de votre organisation de vous donner accès à {{feature}}.",
      },
    },
    dashboard: {
      seeAll: "Voir tout",
      details: "Détails",
      manage: "Gérer",
      edit: "Modifier",
      features: {
        bookings: "les réservations",
        analytics: "les statistiques",
        deals: "les offres et événements",
        restaurantInfo: "les infos restaurant",
      },
      sections: {
        generalStats: "Statistiques générales",
        today: "Aujourd'hui",
        offersAndInfo: "Offres & infos restaurant",
      },
      header: {
        greeting: "Bonjour, {{name}}",
        greetingFallback: "Bonjour",
        activity: "Voici l'activité de {{restaurant}} aujourd'hui.",
        pending_one: "Une réservation attend votre confirmation.",
        pending_other: "{{count}} réservations attendent votre confirmation.",
        noPending: "Toutes les réservations sont confirmées.",
        noBookings: "Aucune réservation aujourd'hui.",
      },
      subscription: {
        plan: "Abonnement",
        nextBilling: "Prochaine facture",
        manage: "Gérer",
        none: "Aucune formule",
      },
      stats: {
        todaysBookings: "Réservations aujourd'hui",
        expectedGuests: "Couverts attendus",
        occupancy: "Taux d'occupation",
        vsLastWeek: "vs sem. dernière",
      },
      todaysBookings: {
        title: "Réservations du jour",
        subtitle: "{{date}} · {{count}} couverts",
        empty: "Aucune réservation aujourd'hui pour le moment.",
      },
      quietSlots: {
        title: "Créneaux creux",
        subtitle: "Tables occupées par tranche · service du jour",
        callout:
          "{{start}} → {{end}} est presque vide. Une offre peut remplir ces tables.",
        createOffer: "Créer une offre",
        emptyService:
          "Aucune réservation pour le moment. Une offre peut lancer le service.",
        noQuietWindow:
          "Aucun creux aujourd'hui — le service se remplit régulièrement.",
        closed: "Le restaurant est fermé aujourd'hui.",
        noSchedule: "Aucun horaire d'ouverture défini pour aujourd'hui.",
      },
      analytics: {
        title: "Statistiques",
        subtitle: "{{days}} derniers jours · réservations & couverts",
        bookings: "Réservations",
        guests: "Couverts",
        bookingsCount_one: "{{count}} réservation",
        bookingsCount_other: "{{count}} réservations",
        trendTitle: "Tendance des réservations",
        peakHours: "Heures de pointe",
      },
      offers: {
        title: "Offres & événements",
        subtitle:
          "{{deals}} offres actives · {{events}} événements actifs · {{total}} au total",
        deal: "Offre",
        event: "Événement",
        active: "Active",
        inactive: "Inactive",
        empty: "Aucune offre ni événement pour le moment.",
      },
      restaurantInfo: {
        title: "Infos restaurant",
        address: "Adresse",
        phone: "Téléphone",
        today: "Aujourd'hui",
        open: "Ouvert",
        closedToday: "Fermé aujourd'hui",
      },
    },
    // Every line of a pricing card: the catalog hands over the key, not the
    // sentence, so a re-worded or re-sold perk is a translation change alone.
    subscription: {
      perk: {
        deals: {
          publish_offers:
            "Publiez vos offres dans notre application grand public",
          publish_events:
            "Publiez vos événements dans notre application grand public",
          recurring_automatic: "Offres récurrentes automatiques",
        },
        booking: {
          same_day: "Gérez les réservations du jour",
          full_management: "Système de gestion de réservation complet",
          floor_plan: "Plan de salle & gestion des tables",
          no_show_blacklist: "Blacklist des no-shows",
        },
        analytics: {
          offers:
            "Analytics de vos offres — couverts générés, conversion, party size, meilleur créneau",
          full: "Analytics complets — remplissage, heures de pointe, récurrence client, historique illimité",
        },
        menu: {
          hosted_page:
            "Gérez votre menu et générez une page dédiée hébergée gratuitement",
        },
        staff: {
          three_accounts: "3 comptes utilisateurs",
          unlimited_accounts_and_roles: "Comptes et rôles illimités",
        },
        service: {
          live_view: "Vue du service en cours",
        },
        boost: {
          one_per_month: "1 boost offert par mois",
        },
        support: {
          whatsapp_7_7: "Support WhatsApp 7j/7",
        },
      },
    },
    payments: {
      pageTitle: "Paiements",
      pageSubtitle:
        "Déclarez le virement que vous avez effectué, suivez sa vérification et consultez tout ce que vous avez réglé.",
      loadError: "Impossible de charger vos paiements. Veuillez réessayer.",
      amount: "{{amount}} MAD",
      months_one: "{{count}} mois",
      months_other: "{{count}} mois",
      type: {
        RENEWAL: "Renouvellement",
        UPGRADE: "Mise à niveau",
      },
      period: {
        MONTHLY: "Mensuel",
        ANNUAL: "Annuel",
      },
      status: {
        PENDING: "En cours de vérification",
        CONFIRMED: "Confirmé",
        REJECTED: "Refusé",
        CANCELLED: "Annulé",
      },
      pending: {
        title: "Paiement en cours de vérification",
        subtitle:
          "Nous vérifions votre virement. Vous ne pouvez pas déclarer un autre paiement tant que celui-ci n'est pas traité.",
        declaredOn: "Déclaré le {{date}}",
        downloadProof: "Télécharger le justificatif",
        replaceProof: "Remplacer le justificatif",
        cancel: "Annuler le paiement",
      },
      replace: {
        title: "Remplacer le justificatif de virement",
        body: "Envoyez un justificatif corrigé. Il remplace celui joint à ce paiement.",
        submit: "Remplacer",
        cancel: "Annuler",
      },
      cancel: {
        title: "Annuler ce paiement ?",
        body: "Le paiement reste dans votre historique comme annulé, et vous pourrez en déclarer un corrigé.",
        confirm: "Annuler le paiement",
        dismiss: "Le conserver",
      },
      history: {
        title: "Historique des paiements",
        subtitle: "Tous les paiements déclarés, du plus récent au plus ancien",
        download: "Télécharger le justificatif",
        rejectionReason: "Motif : {{reason}}",
        columns: {
          date: "Date",
          type: "Type",
          tier: "Formule",
          duration: "Durée",
          amount: "Montant",
          status: "Statut",
          proof: "Justificatif",
        },
        empty: {
          title: "Aucun paiement",
          message: "Déclarez votre premier virement et il apparaîtra ici.",
        },
      },
      declare: {
        title: "Déclarer un paiement",
        subtitle:
          "Effectuez le virement sur le compte ci-dessous, puis joignez le justificatif. Nous le confirmons dès réception.",
        typeLabel: "Objet du paiement",
        tierLabel: "Formule",
        periodLabel: "Périodicité",
        perMonth: "{{amount}} MAD/mois",
        savePercent: "-{{percent}} %",
        saveAmount: "Vous économisez {{amount}} MAD sur l'année",
        periodDuration: "{{period}} · {{duration}}",
        durationLabel: "Durée",
        amountLabel: "Montant attendu",
        amountHint:
          "Affiché d'après le tarif du catalogue. Le montant définitif est celui enregistré sur votre paiement.",
        submit: "Déclarer le paiement",
        cancel: "Annuler",
        renewAction: "Déclarer un paiement",
        upgradeAction: "Demander une mise à niveau",
        highestTier: "Vous êtes déjà sur la formule la plus élevée.",
      },
      bank: {
        title: "Coordonnées bancaires",
        subtitle: "Où envoyer le virement",
        accountHolder: "Titulaire du compte",
        rib: "RIB",
        swift: "Code SWIFT",
        iban: "IBAN",
        ibanHint: "À utiliser pour un virement international.",
        reference: "Référence du virement",
        referenceHint:
          "Indiquez-la en référence du virement pour que nous puissions le rapprocher.",
        copy: "Copier le RIB",
        copied: "RIB copié dans le presse-papiers",
      },
      proof: {
        label: "Justificatif de virement",
        choose: "Joindre un fichier",
        accepted: "JPEG, PNG, HEIC ou PDF, jusqu'à {{size}} Mo.",
        errors: {
          tooLarge:
            "Ce fichier dépasse {{size}} Mo. Veuillez en joindre un plus petit.",
          unsupportedType:
            "Seuls les fichiers JPEG, PNG, HEIC et PDF sont acceptés.",
        },
      },
      errors: {
        missingProof: "Un justificatif de virement et un type de paiement sont requis.",
        forbidden:
          "Vous n'êtes pas autorisé à gérer les paiements de ce restaurant.",
        notFound: "Ce restaurant est introuvable.",
        alreadyPending:
          "Un paiement est déjà en cours de vérification pour ce restaurant, ou celui-ci n'est plus en attente.",
        tooLarge: "Le justificatif dépasse la taille maximale de {{size}} Mo.",
        unsupportedType:
          "Le justificatif doit être un fichier JPEG, PNG, HEIC ou PDF.",
        invalidTier: "Cette formule n'est pas un choix valide pour ce paiement.",
        generic: "Une erreur est survenue. Veuillez réessayer.",
      },
      admin: {
        title: "Paiements",
        subtitle:
          "Vérifier les virements déclarés et les appliquer aux abonnements",
        queueTitle: "File des paiements",
        queueSubtitle: "Du plus récent au plus ancien",
        loadError: "Échec du chargement des paiements",
        resolvedBy: "Traité par {{admin}}",
        filter: {
          label: "Statut",
          all: "Tous les statuts",
        },
        columns: {
          restaurant: "Restaurant",
          actions: "Actions",
        },
        empty: {
          title: "Rien à afficher",
          message: "Aucun paiement ne correspond à ce filtre.",
        },
        actions: {
          preview: "Voir le justificatif",
          confirm: "Confirmer",
          reject: "Refuser",
        },
        proof: {
          title: "Justificatif de virement",
          close: "Fermer",
          downloaded:
            "Ce justificatif ne peut pas être prévisualisé dans le navigateur et a été téléchargé.",
        },
        confirm: {
          title: "Confirmer le paiement de {{restaurant}}",
          body: "Ne modifiez un champ que pour corriger ce qui a été déclaré. Les champs inchangés conservent leur valeur déclarée.",
          renewalConsequence:
            "La confirmation prolonge l'abonnement de ce restaurant. Il n'y a aucune étape après celle-ci.",
          upgradeConsequence:
            "La confirmation accorde la formule cible à partir d'aujourd'hui et abandonne le cycle restant. Il n'y a aucune étape après celle-ci.",
          period: "Périodicité",
          months: "Mois",
          tier: "Formule",
          amount: "Montant",
          submit: "Confirmer le paiement",
          cancel: "Annuler",
          success: "Le paiement de {{restaurant}} a été confirmé.",
          failed: "Échec de la confirmation du paiement",
        },
        reject: {
          title: "Refuser le paiement de {{restaurant}}",
          body: "Le motif est communiqué au restaurateur, et le refus lui permet de déclarer un paiement corrigé. L'abonnement n'est pas modifié.",
          reason: "Motif",
          submit: "Refuser le paiement",
          cancel: "Annuler",
          success: "Le paiement de {{restaurant}} a été refusé.",
          failed: "Échec du refus du paiement",
        },
      },
    },
    sideBar: {
      dashboard: "Tableau de bord",
      mydashboard: "Mon Tableau de Bord",
      myRestaurants: "Mes Restaurants",
      restaurantInfo: "Infos Restaurant",
      openingHours: "Horaires d'ouverture",
      mediaGallery: "Galerie Média",
      menuManagement: "Gestion du Menu",
      menu: "Menu",
      bookings: "Reservations",
      tableSchedule: "Plan de salle",
      deals: "Offres & Événements",
      statistics: "Statistiques",
      logout: "Déconnexion",
      selectRestaurant: "Sélectionner un restaurant",
      myOrganization: "Mon Organisation",
      adminControlPanel: "Panneau d'administration",
      configuration: "Configuration",
      payments: "Paiements",
    },
    staffInvitation: {
      title: "Rejoignez votre équipe",
      subtitle: "Complétez vos informations pour créer votre compte.",
      fields: {
        firstName: "Prénom",
        lastName: "Nom de famille",
        phone: "Numéro de téléphone",
        password: "Mot de passe",
        confirmPassword: "Confirmer le mot de passe",
      },
      cta: "Créer mon compte",
      success:
        "Votre compte a été créé. Vous pouvez maintenant vous connecter avec votre email et votre mot de passe.",
      goToLogin: "Se connecter",
      error: "Une erreur est survenue. Veuillez réessayer.",
      errorPasswordMismatch: "Les mots de passe ne correspondent pas.",
      errorInvalidLink: "Ce lien d'invitation est invalide ou a expiré.",
    },
    subscriptionBanner: {
      title: "Abonnement expiré",
      renewNow: "Renouveler maintenant",
      message_one:
        "L'abonnement de {{restaurant}} a expiré. L'accès sera automatiquement révoqué dans {{count}} jour. Contactez votre administrateur pour le renouveler.",
      message_other:
        "L'abonnement de {{restaurant}} a expiré. L'accès sera automatiquement révoqué dans {{count}} jours. Contactez votre administrateur pour le renouveler.",
      messageToday:
        "L'abonnement de {{restaurant}} a expiré. L'accès sera automatiquement révoqué aujourd'hui. Contactez votre administrateur pour le renouveler.",
      messageUnknown:
        "L'abonnement de {{restaurant}} a expiré et l'accès sera automatiquement révoqué. Contactez votre administrateur pour le renouveler.",
      expiredOn: "Expiré le {{date}}",
    },
    configuration: {
      pageTitle: "Configuration",
      pageSubtitle: "Gérez votre abonnement et les paramètres de votre compte",
      subscription: {
        title: "Abonnement",
        subtitle: "Votre formule actuelle et vos préférences de facturation",
        current: "Actuel",
        loadError: "Impossible de charger les détails de votre abonnement",
        noTier: "Ce restaurant n'a pas encore de formule d'abonnement.",
        nextBillingTitle: "Prochaine facturation",
        nextBillingSubtitle: "Votre abonnement se renouvelle à cette date",
        renewTitle: "Renouveler votre formule",
        renewSubtitle:
          "Déclarez le virement qui règle votre prochaine période de facturation",
        upgradeTitle: "Améliorer la formule",
        upgradeSubtitle:
          "Débloquez la gestion multi-établissements et les analyses avancées",
        renew: "Renouveler mon paiement",
        upgrade: "Améliorer",
        cancelTitle: "Résilier l'abonnement",
        cancelSubtitle:
          "La désinscription met fin à l'abonnement de cet établissement et ferme son tableau de bord",
        unsubscribe: "Se désabonner",
        comingSoon: "Bientôt disponible",
        unsubscribeConfirmTitle: "Désabonner cet établissement ?",
        unsubscribeConfirmBody:
          "Cette action met fin immédiatement à l'abonnement et ferme le tableau de bord de l'établissement. L'établissement reste dans votre organisation avec son historique de paiements, et vous pouvez vous réabonner en déclarant un paiement.",
        unsubscribeConfirm: "Se désabonner",
        unsubscribeCancel: "Annuler",
        unsubscribeSuccess:
          "L'abonnement a été résilié. L'établissement reste dans votre organisation — déclarez un paiement pour vous réabonner.",
        unsubscribeError: "Échec de la désinscription. Veuillez réessayer.",
      },
      account: {
        title: "Détails du compte",
        subtitle: "Vos informations personnelles et coordonnées",
        edit: "Modifier le profil",
        save: "Enregistrer",
        cancel: "Annuler",
        fullName: "Nom complet",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Adresse e-mail",
        phone: "Numéro de téléphone",
        updateSuccess: "Profil mis à jour",
        updateError: "Échec de la mise à jour du profil",
      },
      password: {
        title: "Mot de passe et sécurité",
        subtitle: "Gérez votre mot de passe et la sécurité de votre compte",
        label: "Mot de passe",
        resetHint: "Un lien de réinitialisation sera envoyé à {{email}}",
        sendReset: "Envoyer l'e-mail de réinitialisation",
        resetSuccess: "E-mail de réinitialisation envoyé",
        resetError: "Échec de l'envoi de l'e-mail de réinitialisation",
      },
    },
    myOrganization: {
      pageTitle: "Mon Organisation",
      pageSubtitle: "Gérez le personnel et les rôles de votre organisation",
      summary: {
        title: "Aperçu de l'organisation",
        staff: "Membres du personnel",
        roles: "Rôles",
        restaurants: "{{count}} restaurant(s)",
      },
      tabs: {
        staff: "Mon Personnel",
        roles: "Rôles du Personnel",
      },
      staff: {
        pageTitle: "Membres du Personnel",
        unlimited: "illimité",
        searchPlaceholder: "Rechercher par nom ou email…",
        noStaff: "Aucun membre du personnel trouvé",
        noResults: "Aucun résultat pour cette recherche",
        name: "Nom",
        firstName: "Prénom",
        lastName: "Nom de famille",
        email: "Email",
        phone: "Téléphone",
        role: "Rôle",
        restaurants: "Restaurants assignés",
        invite: "Inviter",
        inviteTitle: "Inviter un membre du personnel",
        inviteSubtitle:
          "Nous lui enverrons un lien sécurisé par email pour créer son compte.",
        inviteEmail: "Adresse email",
        inviteRestaurant: "Affecter à un restaurant",
        inviteSend: "Envoyer l'invitation",
        inviteSuccess: "Invitation envoyée",
        inviteError: "Échec de l'envoi de l'invitation",
        inviteEmailInvalid: "Veuillez saisir une adresse email valide",
        inviteSelectRestaurant: "Veuillez sélectionner un restaurant",
      },
      staffView: {
        pageTitle: "Membre du Personnel",
        back: "Retour",
        updateSuccess: "Membre du personnel mis à jour avec succès",
        updateError: "Échec de la mise à jour du membre",
        deleteSuccess: "Membre supprimé",
        deleteError: "Échec de la suppression du membre",
        deleteConfirmTitle: "Supprimer le Membre",
        deleteConfirmBody: "Êtes-vous sûr de vouloir supprimer {{name}} ? Cette action est irréversible.",
        saveChanges: "Enregistrer",
        delete: "Supprimer",
        assignRole: "Rôle attribué",
        changeRole: "Changer le rôle",
      },
      roles: {
        pageTitle: "Rôles du Personnel",
        createRole: "Créer un rôle",
        noRoles: "Aucun rôle créé pour l'instant",
        name: "Nom du rôle",
        description: "Description",
        descriptionPlaceholder: "Description optionnelle",
        permissions: "Permissions",
        createSuccess: "Rôle \"{{name}}\" créé",
        deleteSuccess: "Rôle \"{{name}}\" supprimé",
        deleteConfirmTitle: "Supprimer le Rôle",
        deleteConfirmBody: "Êtes-vous sûr de vouloir supprimer le rôle \"{{name}}\" ? Les membres ayant ce rôle pourraient être affectés.",
      },
      roleView: {
        pageTitle: "Rôle",
        back: "Retour",
        permissions: "Permissions",
        noPermissions: "Aucune permission disponible pour cette organisation",
        selectedCount: "{{count}} sur {{total}} permissions sélectionnées",
        saveChanges: "Enregistrer",
        updateSuccess: "Permissions du rôle mises à jour avec succès",
        updateError: "Échec de la mise à jour des permissions",
      },
    },
    restaurant: {
      home: {
        header: "Bienvenue {{name}}!",
        kpi: {
          day: "Aujourd'hui",
          twoDays: "Ces deux derniers jours",
          week: "Cette semaine",
          twoWeeks: "Ces deux dernières semaines",
          month: "Ce mois-ci",
          year: "Cette année",
          ownerRanking: "Classement dans l'application",
          ownerRankingDesc: "Le plus visité ce moi-ci",
          bookingsByCity: "Répartition des visiteurs",
          bookings: "Nombre de réservations",
          visitors: "Nombre de visites",
          noDeals: "Vous n'avez pas de deals",
          noBookings: "Vous n'avez pas de réservations",
        },
        bookingsHeader: "Réservations à venir",
        noBookings: "Vous n'avez pas de réservations",
        dealsHeader: "Deals actifs",
        seeAll: "Voir tout",
        seeStats: "Voir toutes les stats",
      },
      restaurantList: {
        header: "Liste des restaurants",
        restaurantName: "Nom du restaurant",
        city: "Ville",
        address: "Adresse",
        rowsPerPage: "Lignes par page",
      },
      addRestaurantPage: {},
      capabilities: {
        header: "Fonctionnalités",
        subheader: "Fonctionnalités et permissions activées pour ce restaurant",
        manage: "Gérer",
        noCapabilities: "Aucune fonctionnalité assignée",
        drawer: {
          title: "Ajouter une fonctionnalité",
          subtitle: "Sélectionnez une fonctionnalité à activer pour ce restaurant",
          noAvailable: "Toutes les fonctionnalités sont déjà assignées",
          add: "Ajouter",
        },
        addSuccess: "Fonctionnalité ajoutée avec succès",
        addError: "Échec de l'ajout de la fonctionnalité",
        removeSuccess: "Fonctionnalité supprimée avec succès",
        removeError: "Échec de la suppression de la fonctionnalité",
      },
      restaurantInfoPage: {
        restaurantInfo: {
          header: "Informations du restaurant",
          subHeader: "Mettez à jour les informations de votre restaurant",
          subheader: "Gérez les informations de base de votre restaurant",
          editCta: "Modifier les informations",
          sections: {
            basic: "Informations de base",
            basicSub: "Les informations principales de votre restaurant que les clients verront",
            location: "Localisation",
            locationSub: "Où vos clients peuvent vous trouver",
            locationCta: "Localisation du restaurant",
            capacity: "Capacité et Tags",
            capacitySub: "Aidez vos clients à savoir à quoi s'attendre",
            services: "Services et Équipements",
            servicesSub: "Quels services proposez-vous à vos clients ?",
            social: "Réseaux sociaux et liens",
            socialSub: "Connectez votre présence en ligne",
          },
          ImportantInformation: {
            header: "Informations importantes",
            uploadSuccess:
              "Informations du restaurant mises à jour avec succès",
            uploadError:
              "Erreur lors de la mise à jour des informations du restaurant",
            fields: {
              name: "Nom du restaurant",
              address: "Adresse",
              city: "Ville",
              phone: "Numéro de téléphone",
              instagram_link: "Lien Instagram",
              booze: "Servez-vous de l'alcool ?",
              animation: "Proposez-vous une animation ?",
              quarter: "Quartier",
              numberOfSeats: "Combien de personnes pouvez-vous accueillir ?",
              numberOfSeatsHint: "Combien de personnes votre restaurant peut-il accueillir ?",
              maximumPartySize: "Taille maximale d'un groupe",
              maximumPartySizePlaceholder: "Aucune limite",
              maximumPartySizeHint:
                "Le plus grand groupe que vous acceptez sur une seule réservation. Laissez vide pour ne fixer aucune limite.",
              tpe: "Acceptez-vous le paiement par tpe ?",
              tpeDesc: "Acceptez-vous les paiements par carte bancaire ?",
              boozeDesc: "Servez-vous des boissons alcoolisées ?",
              animationDesc: "Proposez-vous de la musique live, des spectacles ou autres divertissements ?",
            },
          },
          seeMenuCta: "Voir le Menu",
          cover: {
            header: "Photo de couverture",
            replaceCover: "Remplacer la couverture",
            addCover: "Ajouter une photo de couverture",
            uploadSuccess: "Photo de couverture téléchargée avec succès",
            uploadError:
              "Erreur lors du téléchargement de la photo de couverture",
          },
          tips: {
            title: "Astuces",
            completeProfile: "Un profil complet augmente la visibilité de votre restaurant",
            socialLinks: "Ajoutez vos réseaux sociaux — les clients consultent Instagram avant de venir",
            capacity: "Une capacité précise aide les clients à organiser leurs dîners en groupe en toute confiance",
            tags: "Des tags précis aident les clients à trouver plus facilement votre restaurant",
          },
        },
        imageGallery: {
          header: "Galerie du restaurant",
          subHeader: "Offrez à vos clients un aperçu de votre restaurant",
          uploadSuccess: "Images téléchargées avec succès",
          uploadError: "Erreur lors du téléchargement des images",
        },
        menu: {
          images: {
            header: "Galerie du menu",
            subheader: "Ajoutez des images de votre menu",
            uploadSuccess: "Images téléchargées avec succès",
            uploadError: "Erreur lors du téléchargement des images",
          },
          addSection: "Ajouter une section",
          addDish: "Ajouter un plat",
          save: "Sauvegarder",
          section: {
            name: "Nom de la section",
            itemName: "Nom du plat",
            itemDescription: "Description",
            itemPrice: "Prix",
            uploadSuccess: "Menu mis à jour avec succès",
            uploadError: "Erreur lors de la mise à jour du menu",
          },
        },
        hoursPicker: {
          header: "Horaires d'ouverture",
          subheader:
            "Définissez les horaires d'ouverture et de fermeture de votre restaurant pour chaque jour de la semaine.",
          open: "De",
          close: "À",
          applyToAll: "Ajouter un crénau type",
          typicalDay: "Journée type",
          applyToAllDays: "Appliquer un créneau type à toute la semaine.",
          registerMorning: "Enregistrer les heures du matin",
          registerAfternoon: "Enregistrer les heures du soir",
          uploadSuccess: "Horaires d'ouverture mis à jour avec succès",
          uploadError: "Erreur lors de la mise à jour des horaires d'ouverture",
          switch: "Durée moyenne d'une réservation",
        },
        leaveDays: {
          header: "Jours de congé",
          subheader:
            "Ajoutez des jours de congé à votre calendrier pour informer vos clients de vos fermetures temporaires",
          addLeaveDay: "Ajouter des jours fermés",
        },
        location: {
          header: "Localisation du restaurant",
          subheader:
            "Indiquez l'emplacement de votre restaurant sur la carte pour permettre à vos clients de vous trouver facilement",
          permissions: "Veuillez activer la localisation pour continuer",
          notSupported: "La géolocalisation n'est pas prise en charge par votre navigateur",
          positionUnavailable: "Impossible de récupérer votre position",
          uploadSuccess: "Localisation mise à jour avec succès",
          uploadError: "Erreur lors de la mise à jour de la localisation",
          myPosition: "Prendre ma position",
        },
      },
    },
    bookings: {
      pageTitle: "Réservations",
      pageSubtitle: "Gérez et suivez les réservations de votre restaurant.",
      tips: {
        title: "Astuces",
        responseTime: "Confirmez ou refusez les réservations dans l'heure pour maintenir un bon taux de réponse",
        notes: "Portez attention aux notes laissées par les clients pour repérer les occasions spéciales",
        blacklist: "En cas de no-shows répétés, vous pourrez mettre le client sur liste noire",
      },
      createButton: "Créer une réservation",
      header: "Gestion des réservations",
      subheader: "Consultez et gérez toutes vos réservations passées et futures",
      stats: {
        todaysBookings: "Réservations du jour",
        todaysGuests: "Couverts du jour",
        pending: "En attente",
        upcoming: "À venir",
        todaysNoShows: "No-shows du jour",
      },
      searchPlaceholder: "Rechercher par nom, email ou téléphone...",
      filters: {
        thisWeek: "Cette semaine",
        today: "Aujourd'hui",
        upcoming: "À venir",
        customRange: "Plage personnalisée",
        from: "Du",
        to: "Au",
        allStatuses: "Tous les statuts",
        sameDayOnly:
          "Votre formule couvre les réservations du jour. Passez au module Réservation pour gérer les dates à venir.",
      },
      list: {
        guests: "couverts",
        table: "Table {{number}}",
        unassignedTable: "Non attribuée",
        viewDetails: "Voir les détails",
        noBookings: "Aucune réservation trouvée",
        noBookingsSubtitle: "Essayez d'ajuster vos filtres ou créez une nouvelle réservation.",
        bookingsCount_one: "{{count}} réservation",
        bookingsCount_other: "{{count}} réservations",
        bookingsCount: "{{count}} réservations",
      },
      status: {
        pending: "En Attente",
        cancelled: "Annulée",
        confirmed: "Confirmée",
        checkedIn: "Arrivé",
        noShow: "No-show",
        updateError: "Impossible de mettre à jour le statut de la réservation. Veuillez réessayer.",
        actions: {
          confirm: "Confirmer",
          cancel: "Annuler",
          checkIn: "Marquer arrivé",
          noShow: "No-show",
          correctToCheckedIn: "Corriger en arrivé",
        },
      },
      whatsapp: {
        confirmLabel: "Confirmer via WhatsApp",
        cancelLabel: "Annuler via WhatsApp",
        confirmMessage:
          "Bonjour {{guest}}, votre réservation chez {{restaurant}} pour {{seats}} personne(s) le {{date}} à {{time}} est confirmée. Au plaisir de vous accueillir !",
        cancelMessage:
          "Bonjour {{guest}}, nous sommes au regret de vous informer que votre réservation chez {{restaurant}} pour {{seats}} personne(s) le {{date}} à {{time}} a été annulée. N'hésitez pas à nous contacter pour convenir d'une autre date. Veuillez nous excuser pour la gêne occasionnée.",
      },
      noShowWarning: {
        chip_one: "{{count}} no-show · 30 j",
        chip_other: "{{count}} no-shows · 30 j",
        chip: "{{count}} no-shows · 30 j",
      },
      blacklist: {
        title: "Bloquer ce client ?",
        body_one: "Ce client a {{count}} no-show sur les 30 derniers jours. Bloquer ses futures réservations dans votre restaurant ?",
        body_other: "Ce client a {{count}} no-shows sur les 30 derniers jours. Bloquer ses futures réservations dans votre restaurant ?",
        body: "Ce client a {{count}} no-shows sur les 30 derniers jours. Bloquer ses futures réservations dans votre restaurant ?",
        dismiss: "Plus tard",
        confirm: "Blacklister",
      },
      table: {
        status: "Statut",
        username: "Nom complet",
        phone: "N° de téléphone",
        restaurant: "Restaurant",
        slot: "Horaire",
        deal: "Offre",
        numberOfPeople: "Couverts",
        cancelBooking: "Annuler la réservation",
        confirmBooking: "Confirmer la réservation",
        noBookings: "Vous n'avez aucune réservations pour ce jour",
      },
      modal: {
        confirm: {
          title: "Confirmer la réservation",
          disclaimer: "Êtes-vous sûr de vouloir confirmer cette réservation ?",
        },
        cancel: {
          title: "Annuler la réservation",
          disclaimer: "Êtes-vous sûr de vouloir annuler cette réservation ?",
        },
      },
      detailsModal: {
        title: "Détails de la réservation",
        subtitle: "Toutes les informations sur cette réservation",
        date: "Date",
        time: "Heure",
        partySize: "Couverts",
        phone: "Téléphone",
        email: "Email",
        deal: "Offre",
        close: "Fermer",
        createdAt: "Réservation créée le {{date}}",
      },
      createModal: {
        title: "Créer une réservation",
        subtitle: "Ajoutez une nouvelle réservation pour un client.",
        firstName: "Prénom",
        lastName: "Nom",
        email: "Adresse Email",
        phone: "Numéro de téléphone",
        country: "Pays",
        numberOfSeats: "Nombre de couverts",
        date: "Date et heure",
        notes: "Notes (optionnel)",
        submitButton: "Créer la réservation",
        success: "Réservation créée avec succès",
        error: "Erreur lors de la création de la réservation",
      },
    },
    tableSchedule: {
      pageTitle: "Plan de salle — Grille du jour",
      tableLabel: "T{{number}}",
      tableLabelLong: "Table {{number}}",
      legend: {
        confirmed: "Confirmée",
        pending: "En attente",
        open: "Heures d'ouverture",
        deal: "Offre",
        event: "Événement",
      },
      tableCount: {
        label_one: "{{count}} table",
        label_other: "{{count}} tables",
        addHint: "Ajouter une table",
        removeHint:
          "Retirer la dernière table. Les réservations à venir qui s'y trouvent deviennent non attribuées.",
        error:
          "Impossible de modifier le nombre de tables. Veuillez réessayer.",
      },
      unassigned: {
        title: "Réservations non attribuées ({{count}})",
        hint: "Glissez-en une sur la grille pour l'attabler.",
        dropHere: "Déposez ici pour libérer la table",
        empty:
          "Aucune réservation non attribuée — glissez-en une ici pour libérer sa table.",
      },
      placement: {
        instruction:
          "Choisissez n'importe quel créneau pour placer la réservation de {{name}} — les horaires d'ouverture ne sont pas imposés.",
        cancel: "Annuler",
      },
      block: {
        continuesNextDay: "Se poursuit le lendemain",
        startedPrevDay: "Commencée la veille",
      },
      inspector: {
        title: "Détails de la réservation",
        guest: "Client",
        seats: "Couverts",
        phone: "Téléphone",
        email: "E-mail",
        table: "Table",
        starts: "Début",
        ends: "Fin",
        duration: "Durée",
        status: "Statut",
        notes: "Notes",
        bookedBy: "Réservé par",
        bookedByStaff: "Personnel (ajoutée sur le plan de salle)",
        bookedByGuest: "Client (réservation en ligne)",
        deal: "Offre",
        event: "Événement",
        moveToDate: "Déplacer vers une autre date",
        spansMidnight:
          "Cette réservation dépasse minuit : elle apparaît sur les deux jours comme une seule réservation.",
        outsideOpening:
          "Ce créneau se situe en dehors des horaires d'ouverture du restaurant.",
        cancelBooking: "Annuler la réservation",
        confirmCancel: "Oui, annuler",
        cancelConfirm:
          "Annuler cette réservation ? Elle disparaîtra du plan de salle.",
        cancelError:
          "Impossible d'annuler la réservation. Veuillez réessayer.",
        confirmBooking: "Confirmer la réservation",
        confirmError:
          "Impossible de confirmer la réservation. Veuillez réessayer.",
        close: "Fermer",
      },
      moveError: "Impossible de déplacer la réservation. Veuillez réessayer.",
      conflictError:
        "Cette table a déjà une réservation à cet horaire.",
      newBookingAt: "Table {{table}} · {{time}} · {{date}}",
      status: {
        CONFIRMED: "Confirmée",
        PENDING: "En attente",
        CANCELED: "Annulée",
        CHECKED_IN: "Arrivée",
        NO_SHOW: "Absence",
      },
      setup: {
        title: "Configurez d'abord vos tables",
        description:
          "Avant d'attribuer des réservations aux tables, indiquez le nombre de tables de votre restaurant. Vous pourrez le modifier plus tard.",
        inputLabel: "Nombre de tables",
        submit: "Enregistrer le nombre de tables",
        error: "Une erreur est survenue lors de l'enregistrement. Veuillez réessayer.",
        noPermission:
          "Vous n'avez pas l'autorisation de configurer le nombre de tables.",
      },
    },
    deals: {
      header: "Liste des offres",
      subheader: "Consultez et gérez toutes vos offres",
      tips: {
        title: "Astuces",
        urgency: "Les offres limitées dans le temps créent un sentiment d'urgence — limitez-les à 2 semaines maximum pour de meilleurs résultats",
        multiSlot: "Les événements avec plusieurs créneaux horaires génèrent plus d'engagement que ceux à créneau unique",
        expiry: "Définissez une date d'expiration pour vos offres afin d'éviter toute déception client",
        slowDays: "Associez vos offres à vos journées les plus calmes pour améliorer votre chiffre d'affaires hebdomadaire",
      },
      pageTitle: "Offres & Événements",
      pageSubtitle: "Créez et gérez vos offres spéciales et événements pour votre restaurant.",
      createButton: "Créer une offre",
      edit: "Modifier",
      event: "Evénement",
      deal: "Offre",
      active: "Actif",
      inactive: "Inactif",
      empty: "Aucune offre ou événement trouvé",
      searchPlaceholder: "Rechercher offres et événements...",
      filterAll: "Tous",
      filterDeals: "Offres",
      filterEvents: "Événements",
      stats: {
        total: "Total Offres & Événements",
        activeNow: "Actifs",
        deals: "Offres",
        events: "Événements",
      },
      modal: {
        createTitle: "Créer une offre",
        editTitle: "Modifier l'offre",
        subtitle: "Configurez une nouvelle offre ou un événement pour votre restaurant.",
        name: "Nom",
        type: "Type",
        typeHint: "Les offres sont pour les promotions. Les événements sont pour les occasions spéciales.",
        description: "Description",
        descriptionPlaceholder: "Décrivez l'offre ou l'événement...",
        dates: "Dates",
        selectedDates: "Dates sélectionnées",
        timeSlots: "Créneaux horaires",
        enableDeal: "Activer cette offre",
        enableDealHint: "Les offres désactivées ne seront pas affichées aux clients.",
        createButton: "Créer l'offre",
        selectDates: "Sélectionner une ou plusieurs dates",
        addSlot: "Ajouter",
      },
      addNewDeal: {
        header: "Ajouter une nouvelle offre",
        editHeader: "Modifier l'offre",
        description: "Description de l'offre",
        startTime: "Début",
        endTime: "Fin",
        addSlot: "Ajouter un créneau",
      },
      table: {
        status: "Statut",
        description: "Description",
        restaurant: "Restaurant",
        type: "Type",
      },
      save: "Sauvegarder",
      cancel: "Annuler",
      updateSuccess: "Offre mise à jour avec succès",
      updateError: "Erreur lors de la mise à jour de l'offre",
    },
    statistics: {
      header: {
        title: "Tableau de bord ",
        chooseRestaurant: "Choisissez un restaurant",
        startDay: "Début",
        endDay: "Fin",
      },
      subheader: "Voici toutes les statistiques pour vos restaurants",
      noStatistics: "Vous n'avez pas de statistiques pour ce jour",
      visibilityKpi: {
        clickLabel: "Nombre de personnes qui ont vue votre restaurant",
        bookingLabel:
          "Nombre de personnes qui ont commencé le processus de réservation",
        menuLabel: "Nombre de personnes qui ont consulté votre menu",
      },
      usersCountryKpi: {
        header: "Origine des visiteurs",
        tourist: "Touristes",
        morrocan: "Locaux",
      },
      bookingsByStatusKpi: {
        header: "Réservations groupées par statut",
        pendingLabel: "En attente",
        confirmedLabel: "Confirmée",
        rejectedLabel: "Rejetée",
      },
      bookingsKpiLabel: "Nombre de réservations",
      avgPartySize: "Moyenne de personnes par réservation",
      occupancyLabel: "Taux de remplissage des tables",
      seatsFilledLabel: "Nombre de places remplies",
      visitorsLabel: "Nombre de clicks sur votre restaurant",
      bookingsByStatus: {
        title: "Réservations par statut",
        pending: "En attente",
        confirmed: "Confirmée",
        rejected: "Rejetée",
        tooltip: "Nombre de réservations divisé par statut",
      },
      bookingsTrendByDay: {
        title: "Tendance des réservations par jour",
        tooltip: "Tendance des réservations par jour selon l'heure",
        label: "Heure de la journée",
      },
    },
    gallery: {
      title: "Galerie Média",
      subtitle: "Gérez les photos de votre restaurant et de votre menu pour attirer plus de clients",
      editGallery: "Modifier la galerie",
      cover: {
        title: "Photo de couverture",
        subtitle: "C'est l'image principale que les clients voient sur votre page restaurant",
        currentlyDisplayed: "Actuellement affichée",
        replaceCover: "Remplacer la couverture",
        addCover: "Ajouter une photo de couverture",
      },
      restaurantTab: "Galerie Restaurant",
      menuTab: "Galerie Menu",
      restaurantPhotos: {
        title: "Photos du restaurant",
        subtitle: "Montrez l'ambiance, l'intérieur et l'extérieur de votre restaurant",
      },
      menuPhotos: {
        title: "Photos du menu",
        subtitle: "Présentez vos plats et boissons pour séduire vos clients",
      },
      uploadPhotos: "Ajouter des photos",
      addPhoto: "Ajouter une photo",
      addPhotos: "Ajouter des photos",
      noPhotos: "Aucune photo pour l'instant",
      new: "Nouveau",
      tips: {
        title: "Conseils photos",
        quality: "Utilisez des photos de qualité, bien éclairées (min. 1200×800px)",
        ambiance: "Montrez l'ambiance et les plats signatures de votre restaurant",
        seasonal: "Mettez à jour votre galerie avec les offres saisonnières",
        people: "Les photos avec des personnes obtiennent 3× plus d'interactions",
      },
      saveSuccess: "Galerie mise à jour avec succès",
      saveError: "Erreur lors de la mise à jour de la galerie",
    },
    menu: {
      pageTitle: "Gestion du Menu",
      pageSubtitle: "Organisez et gérez les plats de votre restaurant",
      tips: {
        title: "Astuces",
        featured: "Mettez en avant vos plats les plus vendus grâce au bouton étoile",
        reorder: "Faites glisser les plats pour les réordonner — placez les plats à forte marge en haut de chaque catégorie",
        descriptions: "Gardez des descriptions concises : concentrez-vous sur les ingrédients et le mode de préparation",
        freshness: "Les menus mis à jour régulièrement sont mieux classés et attirent plus de clients réguliers",
      },
      addItem: "Ajouter un Plat",
      addCategory: "Ajouter une Catégorie",
      shareQr: "Partager le QR Code",
      qr: {
        title: "QR Code du Menu Public",
        subtitle: "Imprimez ou téléchargez ce code pour que vos clients scannent et ouvrent votre menu en ligne.",
        print: "Imprimer",
        download: "Télécharger",
        scanHint: "Scannez pour voir le menu",
      },
      searchPlaceholder: "Rechercher des plats...",
      empty: "Aucun plat trouvé",
      featured: "Mettre en avant",
      currency: "MAD",
      filter: {
        allCategories: "Toutes les Catégories",
        nCategories: "{{count}} catégories",
      },
      stats: {
        totalItems: "Total Plats",
        activeItems: "Plats Actifs",
        categories: "Catégories",
        avgPrice: "Prix Moyen",
      },
      modal: {
        item: {
          title: "Ajouter un Nouveau Plat",
          editTitle: "Modifier le Plat",
          subtitle: "Remplissez les informations de votre nouveau plat.",
          name: "Nom du Plat",
          category: "Catégorie",
          description: "Description",
          descriptionPlaceholder: "Décrivez le plat, les ingrédients, la préparation...",
          price: "Prix (MAD)",
          status: "Statut",
          active: "Actif",
          inactive: "Inactif",
          addButton: "Ajouter le Plat",
          saveButton: "Sauvegarder",
        },
        category: {
          title: "Ajouter une Nouvelle Catégorie",
          subtitle: "Créez une nouvelle catégorie pour organiser vos plats.",
          name: "Nom de la Catégorie",
          placeholder: "Ex: Entrées, Plats principaux, Boissons",
          addButton: "Ajouter la Catégorie",
        },
      },
    },
    analytics: {
      pageTitle: "Analytiques",
      pageSubtitle: "Insights et métriques pour votre restaurant",
      dateRange: {
        thisWeek: "Cette semaine",
        thisMonth: "Ce mois-ci",
        thisYear: "Cette année",
        custom: "Personnalisé",
      },
      stats: {
        totalBookings: "Total Réservations",
        guestCount: "Nombre d'Invités",
        avgPartySize: "Taille Moy. Groupe",
        occupancyRate: "Taux d'Occupation",
        vsLastWeek: "vs semaine dernière",
        vsLastPeriod: "vs période précédente",
      },
      trend: {
        title: "Tendance Réservations & Invités",
        subtitle: "Réservations et invités quotidiens sur la période sélectionnée",
        bookings: "Réservations",
        guests: "Invités",
      },
      popularTimes: {
        title: "Horaires Populaires",
        subtitle: "Heures de pointe cette semaine",
        hour: "Heure",
        bookings: "Réservations",
      },
      partySizeDistribution: {
        title: "Distribution Taille des Groupes",
        subtitle: "Répartition par taille de groupe",
      },
      bookingSources: {
        title: "Sources de Réservation",
        subtitle: "Comment les clients vous trouvent",
      },
      dayOfWeek: {
        title: "Performance par Jour",
        subtitle: "Taux d'utilisation par jour",
        bookingsLabel: "{{count}} rés. ({{pct}}%)",
      },
      customerInsights: {
        title: "Insights Clients",
        subtitle: "Comprendre vos clients",
        newCustomers: "Nouveaux Clients",
        newCustomersDesc: "Première visite cette semaine",
        returningCustomers: "Clients Fidèles",
        returningCustomersDesc: "Visité plus d'une fois",
        specialOccasions: "Occasions Spéciales",
        specialOccasionsDesc: "Anniversaires, fêtes, etc.",
      },
      performanceHighlights: {
        title: "Points Forts",
        subtitle: "Réalisations de cette semaine",
      },
      offerPerformance: {
        dealsTitle: "Détail par offre × jour",
        eventsTitle: "Détail par événement × jour",
        offerColumn: "Offre",
        weekTotal: "Couverts",
        totalRow: "Total couverts",
        newBadge: "Nouv.",
        weekdays: {
          mon: "Lu",
          tue: "Ma",
          wed: "Me",
          thu: "Je",
          fri: "Ve",
          sat: "Sa",
          sun: "Di",
        },
      },
    },
    schedule: {
      title: "Horaires d'ouverture",
      subtitle: "Définissez les horaires d'ouverture et de fermeture de votre restaurant pour chaque jour de la semaine",
      weeklySchedule: "Planning hebdomadaire",
      weeklyScheduleSub: "Configurez les horaires d'ouverture pour chaque jour. Ajoutez des horaires après-midi/soir si vous avez une pause.",
      editSchedule: "Modifier le planning",
      open: "Ouvert",
      closed: "Fermé",
      openingTime: "Heure d'ouverture",
      closingTime: "Heure de fermeture",
      addAfternoonEvening: "Ajouter un service après-midi/soir",
      afternoonEvening: "Service après-midi/soir",
      markClosed: "Fermé Ce Jour",
      markOpen: "Ouvrire Ce Jour",
      applyToAll: "Appliqué à Tout",
      remove: "Supprimer",
      reservationDuration: "Durée de réservation",
      reservationDurationDesc: "Sélectionnez la durée de chaque créneau de réservation",
      duration1h: "1h",
      duration1h30: "1h30",
      duration2h: "2h",
      leaveDays: "Jours de congé et exceptions",
      leaveDaysSub: "Jours spéciaux où votre restaurant sera fermé",
      noLeaves: "Aucun jour de congé prévu",
      leaveDay: "Jour de congé",
      manageLeaves: "Gérer les jours de congé",
      bookingDuration: "Paramètres de durée de réservation",
      bookingDurationSub: "Quelle durée doivent avoir les créneaux de réservation dans votre restaurant ?",
      allowDurationChanges: "Autoriser la modification de la durée",
      allowDurationChangesDesc: "Indiquez aux clients qu'ils peuvent utiliser la durée de réservation lors de leur réservation",
      saveSuccess: "Planning mis à jour avec succès",
      saveError: "Erreur lors de la mise à jour du planning",
      tips: {
        title: "Astuces",
        holidays: "Mettez à jour vos horaires avant les jours fériés pour éviter toute confusion chez vos clients",
        closures: "Signalez les fermetures exceptionnelles bien à l'avance pour que vos clients puissent s'organiser",
        bookingDuration: "Ajustez la durée de réservation pour que votre plan de salle reste cohérent",
      },
    },
  },
};
